import React from 'react'

import { Box, PageWrapper } from '@vividseats/vivid-ui-kit'
import type { NextPage } from 'next'

import MainLayout from '@/components/layouts/main-layout'
import { ACCESSIBILITY_IDS, REWARDS_PAGE } from '@/constants'
import { useTrackPageView } from '@/hooks/use-analytics'
import { PageType } from '@/types/app-types'

import RewardHero from './components/reward-hero'
import RewardPerks from './components/reward-perks'
import RewardQuestion from './components/reward-question'
import RewardReviews from './components/reward-reviews'
import RewardTopContent from './components/reward-top-content'
import RewardValues from './components/reward-values/component'

const RewardsPage: NextPage = () => {
    useTrackPageView(PageType.Rewards)

    return (
        <MainLayout white metadata={{ title: REWARDS_PAGE.TITLE }}>
            <Box id={ACCESSIBILITY_IDS.CONTENT} />
            <PageWrapper white>
                <RewardHero />
                <RewardTopContent />
                <RewardPerks />
                <RewardReviews />
                <RewardValues />
                <RewardQuestion />
            </PageWrapper>
        </MainLayout>
    )
}

RewardsPage.displayName = 'RewardsPage'
export default RewardsPage
